var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.chartList),function(item,index){return _c('chart',{key:index,attrs:{"chartName":item.name,"chartType":item.type,"chartStyle":item.style,"chartData":item.data},on:{"click":_vm.chartClick}})}),(!_vm.config)?_c('rb-list',{attrs:{"config":_vm.config,"monitorData":_vm.monitorData}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }